import { createSlice, PayloadAction } from '@reduxjs/toolkit';
type StringKeyValue = {
    [key: string]: string;
};
const initialState:StringKeyValue={}

export const filterSlice = createSlice({
    name: 'charting',
    initialState,
    reducers: {
        setFilter(state, action){
            state=action.payload;
            return state;
        },
        resetFilter(state){
            state=initialState;
            return state;
        }
    }
  });
  
  export const { setFilter, resetFilter } = filterSlice.actions;
  
  export default filterSlice.reducer;
  